<div class="unauthorized-container">
  <div class="card">

    <div class="image-wrapper">
      <img src="assets/access-denied.jpg" alt="Access Denied" class="error-image" />
    </div>

    <h1>403 - Access Denied</h1>

    <p>
      Sorry, you don’t have permission to access this page.
      Please contact the administrator if you believe this is a mistake.
    </p>

    <div class="actions">
      <button class="home-btn" (click)="goHome()">🏠 Go to Home</button>
    </div>

  </div>
</div>